import type SubjectDirectoryEntryView from '@UI/Store/Subjects/Views/SubjectDirectoryEntryView';

/**
 * Immutable View: resolves a dossier's title and type from `{ id }` relations sent elsewhere.
 * `facilityId` is the scope it was fetched for, compared by the screen's `stopOn`.
 */
class SubjectDirectoryListView {
	readonly facilityId: number;
	readonly entries: readonly SubjectDirectoryEntryView[];
	private readonly entriesById: ReadonlyMap<number, SubjectDirectoryEntryView>;

	constructor(facilityId: number, entries: readonly SubjectDirectoryEntryView[]) {
		this.facilityId = facilityId;
		this.entries = entries;
		this.entriesById = new Map(entries.map((entry) => [entry.id, entry]));

		Object.freeze(this);
	}

	titleOf(id: number): string | null {
		return this.entriesById.get(id)?.title ?? null;
	}

	typeIdOf(id: number): number | null {
		return this.entriesById.get(id)?.typeId ?? null;
	}
}

export default SubjectDirectoryListView;
